import { IEntityUsageHistoryItemResponse } from "api/entities/metrics";
import { DAYS_OFFSET, WEEKS_OFFSET, MONTHS_OFFSET } from "constants/formats";
import { Formatters } from "helper/formatters";

export type Series = [number, number];

export class ChartFormatters {
  static convert(
    bytes: string | number,
    fixed: number = 2,
    ceiling?: boolean
  ): string {
    let byteNumber = 0;
    if (typeof bytes === "string") {
      byteNumber = Number(bytes);
    } else {
      byteNumber = bytes;
    }
    if (ceiling) {
      return (
        Formatters.formatNumberUnit(byteNumber, (value: number): string => {
          return Math.ceil(value).toString();
        }) + "B"
      );
    }
    return Formatters.formatStorageSpace(byteNumber, fixed);
  }

  static formatXAxis(
    range: string,
    value: string,
    timestamp?: number,
    opts?: any
  ) {
    const date = new Date(Number(value) * 1000);
    return date.toLocaleTimeString("default", {
      month: !range.includes("D") ? "short" : undefined,
      day: !range.includes("D") ? "2-digit" : undefined,
      hour: "2-digit",
      minute: range.includes("D") ? "2-digit" : undefined,
      second: range.includes("D") ? "2-digit" : undefined,
      hour12: true,
    });
  }

  static extractSeries(data: IEntityUsageHistoryItemResponse[]): {
    sizeSeries: Series[];
    objectCountSeries: Series[];
  } {
    const sizeSeries: Series[] = [];
    const objectCountSeries: Series[] = [];

    data.forEach(({ clock, value }) => {
      const clockNumber = Number(clock);

      if ("size" in value) {
        sizeSeries.push([clockNumber, value.size]);
      }
      if ("count" in value) {
        objectCountSeries.push([clockNumber, value.count]);
      }
    });

    return { sizeSeries, objectCountSeries };
  }

  static TsRange(offset: string) {
    const now = Math.floor(Date.now() / 1000);

    const match = offset.match(/^(\d+)([DWM])$/);
    if (!match) {
      throw new Error(
        "Invalid offset format. Use '<number><unit>' where unit is D (days), W (weeks), or M (months)."
      );
    }

    const value = parseInt(match[1], 10);
    const unit = match[2];

    let secondsOffset;
    switch (unit) {
      case "D": // Days
        secondsOffset = value * DAYS_OFFSET;
        break;
      case "W": // Weeks
        secondsOffset = value * WEEKS_OFFSET;
        break;
      case "M": // Months
        secondsOffset = value * MONTHS_OFFSET;
        break;
      default:
        throw new Error(
          "Unsupported unit. Use D (days), W (weeks), or M (months)."
        );
    }

    const past = now - secondsOffset;
    return [now.toString(), past.toString()];
  }
}
